module.exports = __webpack_public_path__ + "img/notifications.56a1aec6.svg";